import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/Logo.png";
import numberOfQualifiedLeads from "../../../../assets/number-of-qualified-leads.svg";
import styled from "styled-components";

// Styled Components
const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: rgb(248, 248, 248);
`;

const SubContainer = styled.div`
  display: flex;
  width: 80%;
  max-width: 1200px;
  background-color: #000040;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    display: none;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  padding: 60px 40px;
`;

const FormColumn = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 32px;
  color: #ffffff;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormInput = styled.input`
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 8px;
  font-size: 16px;
  color: white;
  background-color: #000040;
  transition: border-color 0.3s, box-shadow 0.3s;

  &:focus {
    outline: none;
    background-color: rgb(3, 3, 81);
    border-color: rgb(255, 89, 89);
    box-shadow: 0 0 0 3px rgba(86, 41, 182, 0.1);
  }

  &::placeholder {
    color: white;
  }
`;

const Button = styled.button`
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const ButtonSuccessLarge = styled(Button)`
  background-color: #ff0000;
  color: white;
  border: none;

  &:hover {
    background-color: rgb(203, 0, 0);
    transform: translateY(-2px);
  }
`;

const ButtonSecondaryLarge = styled(Button)`
  background-color: white;
  color: #000040;
  border: 1px solid #000040;
  margin-top: 16px;

  &:hover {
    background-color: rgba(86, 41, 182, 0.05);
    transform: translateY(-2px);
  }
`;

const FormFooterLink = styled.div`
  text-align: center;
  margin-top: 24px;
  font-size: 14px;

  a {
    color: #ffffff;
    font-weight: 500;

    &:hover {
      text-decoration: underline !important;
    }
  }
`;

const Logo = styled.img`
  width: 125px;
  margin-bottom: 40px;
`;

const IllustrationImage = styled.img`
  width: 300px;
  max-width: 100%;
`;

class LogIn extends Component {
  state = {
    login: {
      email: "",
      password: "",
    },
  };

  handleEmailChange = (event) => {
    let login = { ...this.state.login };
    login.email = event.currentTarget.value;
    this.setState({ login });
  };

  handlePasswordChange = (event) => {
    let login = { ...this.state.login };
    login.password = event.currentTarget.value;
    this.setState({ login });
  };

  loginFormSubmit = (event) => {
    try {
      event.preventDefault();
      this.props.propsToContainer(this.state.login);
    } catch (error) {
      console.log(error.message);
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainContainer>
          <SubContainer>
            <ContentWrapper>
              <Logo src={logo} alt="logo" />
              <IllustrationImage
                className="chatBotSvg"
                src={numberOfQualifiedLeads}
                alt="Qualified Leads Illustration"
              />
            </ContentWrapper>
            <FormWrapper>
              <FormColumn>
                <Title>Sign in</Title>
                <Form>
                  <FormInput
                    type="text"
                    required
                    placeholder="Registered E-mail/Phone"
                    onChange={this.handleEmailChange}
                  />
                  <FormInput
                    type="password"
                    required
                    placeholder="Password"
                    onChange={this.handlePasswordChange}
                  />
                  <ButtonSuccessLarge
                    onClick={this.loginFormSubmit}
                    style={{ marginTop: "40px" }}
                  >
                    Sign in
                  </ButtonSuccessLarge>
                  <FormFooterLink>
                    <Link to="/forgotpassword">Forgot password?</Link>
                  </FormFooterLink>
                  <FormFooterLink style={{ marginTop: "8px" }}>
                    <Link to="/registration">New User? Get Onboarded!</Link>
                  </FormFooterLink>
                </Form>
              </FormColumn>
            </FormWrapper>
          </SubContainer>
        </MainContainer>
      </React.Fragment>
    );
  }
}

export default LogIn;
